/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export type ThemeVariantType = 'light' | 'dark';

export interface ThemeVariantPayload {
    variant: ThemeVariantType;
}

export class SetThemeVariant {
    static readonly type = '[Theme] Set variant';

    constructor(public payload: ThemeVariantPayload) {}
}
